import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import HowItWorks from './components/HowItWorks';
import TrustIndicators from './components/TrustIndicators';
import ValueProposition from './components/ValueProposition';
import ProductCategories from './components/ProductCategories';
import WhyBuyDirect from './components/WhyBuyDirect';
import TrustCredibility from './components/TrustCredibility';
import GlobalReach from './components/GlobalReach';
import IndustriesServed from './components/IndustriesServed';
import SocialProof from './components/SocialProof';
import QuoteRequestForm from './components/QuoteRequestForm';
import PlanUploadSection from './components/PlanUploadSection';
import FinalCTA from './components/FinalCTA';
import { useSEO } from '../../utils/seo';

const HomePage = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://goglobalworld.net';
  
  useSEO({
    title: 'Wholesale Construction Materials Save 20-40%',
    description: 'Direct import building materials from global manufacturers. Wholesale construction materials supplier for custom home builders, developers, and contractors across Canada. Steel building supplier, bulk construction materials, kitchens, windows, flooring. Eliminate middleman markup and save 20-40% on your construction costs with factory-direct pricing.',
    keywords: 'construction material sourcing, wholesale building materials, steel building, direct manufacturer sourcing, construction procurement, import building materials Canada, commercial construction supply',
    canonical: `${siteUrl}/`,
    ogImage: 'https://public.readdy.ai/ai/img_res/db54a49a18ca960454e79d5aacec5261.jpg',
    schema: {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: 'Go Global Inc.',
      description: 'Direct import wholesale construction materials supplier. Save 20-40% on building supplies by buying direct from global manufacturers. Steel buildings, kitchens, windows, flooring, and finishes delivered to your jobsite.',
      url: siteUrl,
      logo: `${siteUrl}/favicon.ico`,
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Edmonton',
        addressRegion: 'AB',
        addressCountry: 'CA',
      },
      contactPoint: {
        '@type': 'ContactPoint',
        email: 'info@goglobalinc.com',
        contactType: 'Customer Service',
        availableLanguage: 'English',
      },
      areaServed: [
        { '@type': 'Place', name: 'Canada' },
        { '@type': 'Place', name: 'Alberta' },
        { '@type': 'Place', name: 'British Columbia' },
        { '@type': 'Place', name: 'Ontario' },
        { '@type': 'Place', name: 'Quebec' },
        { '@type': 'Place', name: 'North America' },
        { '@type': 'Place', name: 'South America' },
        { '@type': 'Place', name: 'Caribbean' },
        { '@type': 'Place', name: 'Africa' },
      ],
      slogan: 'Build. Source. Deliver.',
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '4.9',
        reviewCount: '127',
      },
      hasOfferCatalog: {
        '@type': 'OfferCatalog',
        name: 'Construction Materials',
        itemListElement: [
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Product',
              name: 'Wholesale Construction Materials',
              description: 'Direct import building materials with 20-40% cost savings'
            }
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Product',
              name: 'Steel Building Packages',
              description: 'Factory-direct steel building supplier for commercial and industrial projects'
            }
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Product',
              name: 'Bulk Construction Materials',
              description: 'Wholesale building supplies for developers and contractors'
            }
          }
        ]
      }
    },
  });

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <main>
        <HeroSection />
        <TrustIndicators />
        <HowItWorks />
        <ValueProposition />
        <ProductCategories />
        <QuoteRequestForm />
        <WhyBuyDirect />
        <PlanUploadSection />
        <TrustCredibility />
        <GlobalReach />
        <IndustriesServed />
        <SocialProof />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
